import styles from './Modals.module.css'

interface ImageLightboxProps {
  imageUrl: string
  onClose: () => void
}

function ImageLightbox({ imageUrl, onClose }: ImageLightboxProps) {
  return (
    <div
      className={styles.lightboxOverlay}
      onClick={onClose}
    >
      <div
        className={styles.lightboxContent}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className={styles.lightboxClose}
          onClick={onClose}
        >
          ×
        </button>
        <img
          src={imageUrl}
          alt='Full size'
          className={styles.lightboxImage}
        />
      </div>
    </div>
  )
}

export default ImageLightbox
